var Theme = Theme || {};

Theme.ChapterAbstract = (function ($) {

    return {
        init: _init
    };

    function _init() {
        initChapterAbstractClickEvent();
    }

    function initChapterAbstractClickEvent() {
        $('.master-main').on('click', '.js-showChapterAbstractLink', function (e) {
            let $curentTarget = $(e.currentTarget);
            let $wrapperDiv = $curentTarget.closest('div[data-chapter-abstract-to-be-fetched-wrapper]');
            let chapterId = $wrapperDiv.attr('data-chapterid-for-abstract');
            let bookId = $wrapperDiv.attr('data-bookid-for-abstract');
            let $triedFetchDiv = $wrapperDiv.children('div[data-tried-to-fetch-abstract]').first();
            let triedFetch = $triedFetchDiv.attr('data-tried-to-fetch-abstract') === 'true';
            let $abstractLocation = $(`#abstract-${chapterId}`);
            let $baseSiteUrl = $('#hfSiteURL');
            let abstractLinks = $(`#abstract-${chapterId}-links`);
            let ajaxData = { chapterId: chapterId, bookId: bookId };
            let ajaxUrl = $curentTarget.parent().attr('data-link-chapter-abstract-type') == 'extract' ? '/PlatformBook/ChapterAbstractOrExtractAjax' : '/PlatformBook/ChapterAbstractAjax';
            let $thisAbstractIcon = $wrapperDiv.find('.abstract-toggle-icon');
            let toggleIconClass = $thisAbstractIcon.attr('data-icon-class');
            let downArrow = `${toggleIconClass}-down`;
            let upArrow = `${toggleIconClass}-up`;

            if ($baseSiteUrl && $baseSiteUrl.val()) {
                ajaxUrl = '//' + $baseSiteUrl.val() + ajaxUrl;
            }

            $abstractLocation.closest('li').toggleClass('abstractExpanded');

            if (!triedFetch) {
                _fetchAbstractData();
            }

            $abstractLocation.toggleClass('hide');
            $thisAbstractIcon.toggleClass(downArrow);
            $thisAbstractIcon.toggleClass(upArrow);
            _toggleAriaExpanded();

            function _fetchAbstractData() {
                SCM.Ajax.get(ajaxUrl, ajaxData)
                    .expectActionResultModel()
                    .ensureSuccess()
                    .then(_populateAbstractLocation)
                    .then(_setTriedFetchDivToTrue)
                    .catch(console.error);
            }

            function _populateAbstractLocation(ajaxResponse) {
                $abstractLocation.html(ajaxResponse.Html);
                $abstractLocation.append(abstractLinks.html());
                SCM.Utilities.LazyLoad.init('lazy');
            }

            function _setTriedFetchDivToTrue() {
                $triedFetchDiv.attr('data-tried-to-fetch-abstract', 'true');
            }

            function _toggleAriaExpanded() {
                $curentTarget.attr('aria-expanded', $curentTarget.attr('aria-expanded') === 'false' ? 'true' : 'false');
            }

        });
    }

})(jQuery);
